import { SvgIcon, SvgIconProps } from '@mui/material';
import { white } from '@/lib/colours';

export function DashboardIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="dashboard" clipPath="url(#clip0_941_27130)">
          <path
            id="Vector"
            d="M4 13.001H10C10.55 13.001 11 12.551 11 12.001V4.00098C11 3.45098 10.55 3.00098 10 3.00098H4C3.45 3.00098 3 3.45098 3 4.00098V12.001C3 12.551 3.45 13.001 4 13.001ZM4 21.001H10C10.55 21.001 11 20.551 11 20.001V16.001C11 15.451 10.55 15.001 10 15.001H4C3.45 15.001 3 15.451 3 16.001V20.001C3 20.551 3.45 21.001 4 21.001ZM14 21.001H20C20.55 21.001 21 20.551 21 20.001V12.001C21 11.451 20.55 11.001 20 11.001H14C13.45 11.001 13 11.451 13 12.001V20.001C13 20.551 13.45 21.001 14 21.001ZM13 4.00098V8.00098C13 8.55098 13.45 9.00098 14 9.00098H20C20.55 9.00098 21 8.55098 21 8.00098V4.00098C21 3.45098 20.55 3.00098 20 3.00098H14C13.45 3.00098 13 3.45098 13 4.00098Z"
            fill={white[900]}
          />
        </g>
        <defs>
          <clipPath id="clip0_941_27130">
            <rect
              width="24"
              height="24"
              fill={white[900]}
              transform="translate(0 0.000976562)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
